"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillLogBeet = exports.FillLog = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const QuoteAtomsPerBaseAtom_1 = require("./QuoteAtomsPerBaseAtom");
const BaseAtoms_1 = require("./BaseAtoms");
const QuoteAtoms_1 = require("./QuoteAtoms");
/**
 * Holds the data for the {@link FillLog} Account and provides de/serialization
 * functionality for that data
 *
 * @category Accounts
 * @category generated
 */
class FillLog {
    market;
    maker;
    taker;
    baseMint;
    quoteMint;
    price;
    baseAtoms;
    quoteAtoms;
    makerSequenceNumber;
    takerSequenceNumber;
    takerIsBuy;
    isMakerGlobal;
    padding;
    constructor(market, maker, taker, baseMint, quoteMint, price, baseAtoms, quoteAtoms, makerSequenceNumber, takerSequenceNumber, takerIsBuy, isMakerGlobal, padding /* size: 14 */) {
        this.market = market;
        this.maker = maker;
        this.taker = taker;
        this.baseMint = baseMint;
        this.quoteMint = quoteMint;
        this.price = price;
        this.baseAtoms = baseAtoms;
        this.quoteAtoms = quoteAtoms;
        this.makerSequenceNumber = makerSequenceNumber;
        this.takerSequenceNumber = takerSequenceNumber;
        this.takerIsBuy = takerIsBuy;
        this.isMakerGlobal = isMakerGlobal;
        this.padding = padding;
    }
    /**
     * Creates a {@link FillLog} instance from the provided args.
     */
    static fromArgs(args) {
        return new FillLog(args.market, args.maker, args.taker, args.baseMint, args.quoteMint, args.price, args.baseAtoms, args.quoteAtoms, args.makerSequenceNumber, args.takerSequenceNumber, args.takerIsBuy, args.isMakerGlobal, args.padding);
    }
    /**
     * Deserializes the {@link FillLog} from the data of the provided {@link web3.AccountInfo}.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static fromAccountInfo(accountInfo, offset = 0) {
        return FillLog.deserialize(accountInfo.data, offset);
    }
    /**
     * Retrieves the account info from the provided address and deserializes
     * the {@link FillLog} from its data.
     *
     * @throws Error if no account info is found at the address or if deserialization fails
     */
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) {
            throw new Error(`Unable to find FillLog account at ${address}`);
        }
        return FillLog.fromAccountInfo(accountInfo, 0)[0];
    }
    /**
     * Provides a {@link web3.Connection.getProgramAccounts} config builder,
     * to fetch accounts matching filters that can be specified via that builder.
     *
     * @param programId - the program that owns the accounts we are filtering
     */
    static gpaBuilder(programId = new web3.PublicKey('MNFSTqtC93rEfYHB6hF82sKdZpUDFWkViLByLd1k1Ms')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.fillLogBeet);
    }
    /**
     * Deserializes the {@link FillLog} from the provided data Buffer.
     * @returns a tuple of the account data and the offset up to which the buffer was read to obtain it.
     */
    static deserialize(buf, offset = 0) {
        return exports.fillLogBeet.deserialize(buf, offset);
    }
    /**
     * Serializes the {@link FillLog} into a Buffer.
     * @returns a tuple of the created Buffer and the offset up to which the buffer was written to store it.
     */
    serialize() {
        return exports.fillLogBeet.serialize(this);
    }
    /**
     * Returns the byteSize of a {@link Buffer} holding the serialized data of
     * {@link FillLog}
     */
    static get byteSize() {
        return exports.fillLogBeet.byteSize;
    }
    /**
     * Fetches the minimum balance needed to exempt an account holding
     * {@link FillLog} data from rent
     *
     * @param connection used to retrieve the rent exemption information
     */
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(FillLog.byteSize, commitment);
    }
    /**
     * Determines if the provided {@link Buffer} has the correct byte size to
     * hold {@link FillLog} data.
     */
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === FillLog.byteSize;
    }
    /**
     * Returns a readable version of {@link FillLog} properties
     * and can be used to convert to JSON and/or logging
     */
    pretty() {
        return {
            market: this.market.toBase58(),
            maker: this.maker.toBase58(),
            taker: this.taker.toBase58(),
            baseMint: this.baseMint.toBase58(),
            quoteMint: this.quoteMint.toBase58(),
            price: this.price,
            baseAtoms: this.baseAtoms,
            quoteAtoms: this.quoteAtoms,
            makerSequenceNumber: (() => {
                const x = this.makerSequenceNumber;
                if (typeof x.toNumber === 'function') {
                    try {
                        return x.toNumber();
                    }
                    catch (_) {
                        return x;
                    }
                }
                return x;
            })(),
            takerSequenceNumber: (() => {
                const x = this.takerSequenceNumber;
                if (typeof x.toNumber === 'function') {
                    try {
                        return x.toNumber();
                    }
                    catch (_) {
                        return x;
                    }
                }
                return x;
            })(),
            takerIsBuy: this.takerIsBuy,
            isMakerGlobal: this.isMakerGlobal,
            padding: this.padding,
        };
    }
}
exports.FillLog = FillLog;
/**
 * @category Accounts
 * @category generated
 */
exports.fillLogBeet = new beet.BeetStruct([
    ['market', beetSolana.publicKey],
    ['maker', beetSolana.publicKey],
    ['taker', beetSolana.publicKey],
    ['baseMint', beetSolana.publicKey],
    ['quoteMint', beetSolana.publicKey],
    ['price', QuoteAtomsPerBaseAtom_1.quoteAtomsPerBaseAtomBeet],
    ['baseAtoms', BaseAtoms_1.baseAtomsBeet],
    ['quoteAtoms', QuoteAtoms_1.quoteAtomsBeet],
    ['makerSequenceNumber', beet.u64],
    ['takerSequenceNumber', beet.u64],
    ['takerIsBuy', beet.bool],
    ['isMakerGlobal', beet.bool],
    ['padding', beet.uniformFixedSizeArray(beet.u8, 14)],
], FillLog.fromArgs, 'FillLog');
